import { useEffect, useMemo, useState } from "react";

const CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export function random(min, max): number {
  return min + (max - min) * Math.random();
}

export function randomSelect<T>(arr: readonly T[]): T | undefined {
  return arr[Math.floor(random(0, arr.length))];
}

export const randomString = (n: number): string => {
  return [...crypto.getRandomValues(new Uint8Array(n))]
    .map((x, i) => (i = Math.floor((x / 255) * (CHARS.length - 1))))
    .map((idx) => CHARS[idx])
    .join("");
};

/**
 * Hook that eventually evaluates to a random value bounded by `min` and `max`,
 * but starts as `min`.
 */
export function useRandom(min: number, max: number): number {
  return useMemo(() => random(min, max), []);
}

/**
 * Hook that eventually evaluates to a random element of `arr`, but
 * starts as the first element of `arr`.
 */
export function useRandomSelectionFrom<T>(arr: readonly T[]): T | undefined {
  return useMemo(() => randomSelect(arr), []);
}
